export default{
    section:'section',
    sectionTitle: 'title',
    sectionStatus: 'status',
    sections:'Sections',
    editSection:'Edit Section',
    addSection:'Add Section',
}